import { defineMessages } from 'react-intl';

export default defineMessages({
  filtersetEditorHeader: {
    description: 'Filter Editor name entry header',
    defaultMessage: 'This filter can be used to isolate groups of orders that share common characteristics of your choosing.',
    id: 'KJ1Okx',
  },
  filtersetEditorNameLabel: {
    description: 'Filter Editor name entry label',
    defaultMessage: 'Name',
    id: 'QMYX5i',
  },
  filtersetEditorDescriptionLabel: {
    description: 'Filter Editor Description entry label',
    defaultMessage: 'Description',
    id: 'vVrtHh',
  },
  filtersetEditorSupplemental: {
    description: 'Filter Editor Supplemental',
    defaultMessage: 'This filter will match any order that matches <b>ALL of the following criteria.</b>',
    id: 'erFMSF',
  },
});
